// VYBER_PARTNERA — jeden výber partnera (zákazníka) s „+ Vytvoriť partnera“ pre celý Matrix (ústava 56.11, 0.J). PARTNER_KONTROLA_V1 (26. 10. 2026):
// nahradil ZakaznikVyber (NovaZakazkaV3, zakaznik_vytvorit_v1) aj CustomerCombobox (ZakazkyView). Keď partner nie je v zozname, otvorí zdieľané okno
// nového partnera; napísané IČO ide do poľa IČO, nie do názvu. Okno skontroluje Matrix aj adresár MKsoftu a ponúkne existujúceho (Použiť).
// Nový alebo použitý partner sa hneď vyberie a zoznam partnerov sa obnoví (udalosť matrix-customers-changed); kým príde, drží ho lokálne.
import React, { useMemo, useState } from 'react'
import { SearchableSelect } from './Ui.jsx'
import NoviCustomerDialog from './NoviCustomerDialog.jsx'

const jeIco = (t) => /^\d{6,10}$/.test(String(t || '').replace(/[\s.\-/]/g, ''))
export const moznostPartnera = (c) => ({ value: c.id, label: `${c.name} (${c.id})${c.ico ? ' · IČO ' + c.ico : ''}` })

export default function VyberPartnera({ value, onChange, moznosti = [], error = false, placeholder = 'Hľadať partnera (názov / IČO / ID)…' }) {
  const [novy, setNovy] = useState(null)       // predvyplnenie okna: { name } alebo { ico, kind: 'firma' }
  const [pridani, setPridani] = useState([])
  const opts = useMemo(() => [...moznosti, ...pridani.filter(x => !moznosti.some(m => String(m.value) === String(x.value)))], [moznosti, pridani])
  const prijmi = (c) => {
    setPridani(x => x.some(o => String(o.value) === String(c.id)) ? x : [...x, moznostPartnera(c)])
    onChange(c.id); setNovy(null)
    window.dispatchEvent(new CustomEvent('matrix-customers-changed'))
  }
  return <>
    <SearchableSelect value={value || ''} options={opts} placeholder={placeholder} allowCreate menuPortal error={!!error}
      createLabel={t => jeIco(t) ? `+ Vytvoriť partnera s IČO ${String(t).replace(/\D/g, '')}` : `+ Vytvoriť partnera „${t}“`}
      onChange={v => {
        if (v && !opts.some(o => String(o.value) === String(v))) { const t = String(v).trim(); setNovy(jeIco(t) ? { ico: t.replace(/\D/g, ''), kind: 'firma' } : { name: t }) }
        else onChange(v)
      }} />
    {novy && <NoviCustomerDialog open prefill={novy} onClose={() => setNovy(null)} onCreated={prijmi} onExistujuci={prijmi} />}
  </>
}
